/**
 * Auth hub URL for unified auth flow (v3 - reboot-app.soax.com).
 * When unauthenticated or on logout, v2 redirects users here.
 */
export const AUTH_HUB_URL =
  process.env.REACT_APP_AUTH_HUB_URL || 'https://reboot-app.soax.com'

export const AUTH_HUB_LOGOUT_URL = `${AUTH_HUB_URL}/logout`
